module.exports = __webpack_public_path__ + "static/media/santarosa_deusto.94966b58.png";